/**
 * 最新資訊文章 mock 資料。
 * 對應 API: GET /api/news
 */
export const NEWS = [
  {
    id: 'n-1', category: '業界新訊', title: 'TARGET 推出 SERENO G2 鈴木徹選手簽名款 11/15 全亞洲同步上市',
    summary: '歷時 14 個月研發，G2 升級鎢含量至 95%、調整刻紋深度 0.05mm，重心後移 1.2mm。台灣首批 200 套於 MICHIDART 獨家發售，會員可於 11/12 享 24 小時優先預訂。',
    date: '2025.11.05', readTime: '5 MIN READ', theme: 'dark', featured: true, rotate: 0,
  },
  {
    id: 'n-2', category: '選手專訪', title: '專訪 鈴木徹：「擲標的瞬間，是與自己對話的時刻」',
    summary: '從業 15 年的鈴木徹談起 G2 系列的設計思路，以及為什麼飛鏢對他而言不只是運動，而是一種修行。',
    date: '2025.11.04', readTime: '8 MIN', theme: 'dark',
  },
  {
    id: 'n-3', category: '比賽資訊', title: '2025 PERFECT 台灣公開賽 · 12/06 台北南港展覽館登場',
    summary: '總獎金 NT$80 萬，公開組、女子組、業餘組同步開放報名。MICHIDART 為官方指定贊助商。',
    date: '2025.11.02', readTime: '3 MIN', theme: '',
  },
  {
    id: 'n-4', category: '飛鏢知識', title: '新手選標指南：從 18g 到 25g，哪個重量適合你？',
    summary: '飛鏢的重量影響擲法、軌跡、力道。本篇用三張圖解說明三種主流重量區間的差異。',
    date: '2025.10.30', readTime: '6 MIN', theme: 'gold',
  },
  {
    id: 'n-5', category: '業界新訊', title: 'L-style EZ FLIGHT dragon 限定款回歸 · 全台 500 套',
    summary: '絕版兩年的 dragon 系列終於回歸，金箔燙印工藝與漸層藍底色完整復刻，附 L-shaft 套組。',
    date: '2025.10.27', readTime: '4 MIN', theme: '',
  },
  {
    id: 'n-6', category: '飛鏢知識', title: '練習動線設計：在家如何打造一個合規的練習空間',
    summary: '飛鏢盤距離地面 1.73m、投擲線 2.37m。本篇示範三種台灣常見坪數的擺設方案。',
    date: '2025.10.22', readTime: '7 MIN', theme: 'dark',
  },
  {
    id: 'n-7', category: '比賽資訊', title: 'PHOENIX 全國個人爭霸戰 · 11/30 高雄場結果出爐',
    summary: '恭喜本店常客王育麟以 105.8 平均拿下公開組第三名！比賽精彩集錦影片同步上線。',
    date: '2025.10.18', readTime: '3 MIN', theme: 'gold',
  },
];

/**
 * 首頁底部用的精簡卡片版本（角度旋轉裝飾）。
 * 後台串接時可由 `getNews({ limit: 3, decorative: true })` 動態派生。
 */
export const HOME_NEWS_DECOR = [
  { rotate: -18 }, { rotate: 12 }, { rotate: -6 },
];

/**
 * 即將舉辦的賽事 / 活動。
 * 對應 API: GET /api/events
 */
export const UPCOMING_EVENTS = [
  { day: '15', month: 'NOV', title: 'SERENO G2 發售體驗會', desc: '鈴木徹本人親臨簽名，限額 50 名。', loc: 'MICHIDART 信義店' },
  { day: '06', month: 'DEC', title: '2025 PERFECT 台灣公開賽', desc: '三日制 · 公開組 / 女子組 / 業餘組。', loc: '南港展覽館 2 館' },
  { day: '21', month: 'DEC', title: '道 · 年度聚會 Year-End Cup', desc: '會員限定，獎品總值 NT$30 萬。', loc: '台北 · 公館旗艦店' },
];
